import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { TypedVehicle } from "./vehicle.query";
import { TypedUser } from "interface/user.model";
import helpers from "helpers/index";


// type TypedDateFilter = {
//     createdAt?: string | number;
//     [propName: string]: any;
// };


export function useGetTodayTripManifest() {
    return useQuery({
        queryKey: ['analytics/today/trip_manifest'],
        queryFn: () => axios.get<{
            [propName: string]: number
        }>(`/analytics/today/trip_manifest`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetTodayOrders() {
    return useQuery({
        queryKey: ['analytics/today/order'],
        queryFn: () => axios.get<{
            [propName: string]: number
        }>(`/analytics/today/order`).then((response) => response.data),
        retry: 1,
    });
}


export function useGetTodaySeatFillRate() {
    return useQuery({
        queryKey: ['analytics/today/seat_fill_rate'],
        queryFn: () => axios.get<{
            [propName: string]: number
        }>(`/analytics/today/seat_fill_rate`).then((response) => response.data),
        retry: 1,
    });
}

/** Xếp hạng tạm thời nhân viên hôm nay widget */
export function useGetTodayStaffRank() {
    return useQuery({
        queryKey: ['analytics/today/staff_rank'],
        queryFn: () => axios.get<{
            "user_id": number,
            "display_name": string,
            "user_avatar"?: string | null,
            "totalOrders": number,
            "totalRevenue": number,
        }[]>(`/analytics/today/staff_rank`).then((response) => response.data),
        refetchInterval: 30000,
        refetchOnWindowFocus: true,
    });
}

/** Widget xếp hạng theo tháng eii */
export function useGetThisMonthlyStaffRank(object: {
    month: string | number,
    year: string | number
}) {
    return useQuery({
        queryKey: ['analytics/monthly/staff_rank', object],
        queryFn: () => axios.get<{
            "user_id": number,
            "display_name": string,
            "user_avatar"?: string | null,
            "totalOrders": number,
            "totalRevenue": number,
        }[]>(`/analytics/monthly/staff_rank${helpers.buildEndUrl(object)}`).then((response) => response.data),
        refetchOnWindowFocus: true,
    });
}

/** chỉ phục vụ widget trang chủ */
export function useGetTodayJourneyRank() {
    return useQuery({
        queryKey: ['analytics/today/revenue_by_journey'],
        queryFn: () => axios.get<{
            "journey_id": string,
            "journey_name": string,
            "order_count": number,
            "revenue": number
        }[]>(`/analytics/today/revenue_by_journey`).then((response) => response.data),
        retry: 1,
    });
}

type TYPED_BUSY_VEHICLE = TypedVehicle & { _count: { trip_manifest: number } };
export function useGetVehicleStatus() {
    return useQuery({
        queryKey: ['analytics/today/vehicle_status'],
        queryFn: () => axios.get<{
            "BUSY_VEHICLE": TYPED_BUSY_VEHICLE[],
            "FREE_VEHICLE": TypedVehicle[]
        }>(`/analytics/today/vehicle_status`).then((response) => response.data),
        retry: 1,
    });
}

type TYPED_BUSY_DRIVER = TypedUser & { _count: { trip_manifest_driver: number } };
export function useGetDriverStatus() {
    return useQuery({
        queryKey: ['analytics/today/driver_status'],
        queryFn: () => axios.get<{
            "BUSY_DRIVER": TYPED_BUSY_DRIVER[],
            "FREE_DRIVER": TypedUser[]
        }>(`/analytics/today/driver_status`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetPhoneCallStatus() {
    return useQuery({
        queryKey: ['analytics/today/phonecall'],
        queryFn: () => axios.get<any>(`/analytics/today/phonecall`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetMonthConversion() {
    return useQuery({
        queryKey: ['analytics/month/conversion'],
        queryFn: () => axios.get<any>(`/analytics/month/conversion`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetMonthGeographic() {
    return useQuery({
        queryKey: ['analytics/month/geographic'],
        queryFn: () => axios.get<any>(`/analytics/month/geographic`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetMonthPassengerVSGood() {
    return useQuery({
        queryKey: ['analytics/month/passenger_good_rate'],
        queryFn: () => axios.get<any>(`/analytics/month/passenger_good_rate`).then((response) => response.data),
        retry: 1,
    });
}

export function useGetDriverStats(object: { startDate: string, endDate: string }) {
    return useQuery({
        queryKey: ['analytics/driver_analytics', object],
        queryFn: () => axios.get<{ "user_id": string, "display_name": string, "user_phonenumber": string, "total_trip_manifest": number, "total_trip_mainline": number, "total_trip_shuttle": number }[]>(`/analytics/driver_analytics${helpers.buildEndUrl(object)}`).then((response) => response.data),
        retry: 1,
    });
}
export function useGetFinalDriverRevenue(object: { startDate: string, endDate: string }) {
    return useQuery({
        queryKey: ['analytics/final_driver_revenue', object],
        queryFn: () => axios.get<{
            "user_id": string,
            "display_name": string,
            "user_phonenumber": string,
            "total_trip_manifest": number,
            "total_trip_mainline": number,
            "total_trip_shuttle": number,
            "total_as_driver": number;
            "total_as_assistant": number;

            /** Tài xế chưa nộp lệnh */
            "money_uncollected_total": number;



            "workload_percent": number,
            "rank": number,
            "is_top": number
        }[]>(`/analytics/final_driver_revenue${helpers.buildEndUrl(object)}`).then((response) => response.data),
        retry: 1,
    });
}


/** Tải về excel bản đang xem */
export function useDownloadDriverRevenue() {
    return useMutation({
        mutationKey: ["analytics/final_driver_revenue/download"],
        mutationFn: (object: { startDate: string, endDate: string, user_id: string }) => axios.get<Blob>(`/analytics/final_driver_revenue/download${helpers.buildEndUrl(object)}`, { responseType: 'blob', }).then(response => response.data),
    })
}


/** 
 * Thống kê sơ bộ thu nhập của nhân viên, hiển thị tại dashboard 
 * @deprecated - remove now
*/
export function useGetStaffRevenue(object: { startDate: string, endDate: string }) {
    return useQuery({
        queryKey: ['analytics/staff_revenue', object],
        queryFn: () => axios.get<{
            "user_id": string,
            "display_name": string,
            "user_phonenumber": string,
            "total_all": number,
            "total_cancelled": number,
            "total_success": number,
            "revenue": number,

        }[]>(`/analytics/staff_revenue${helpers.buildEndUrl(object)}`).then((response) => response.data),
        retry: 1,
    });
}

/** Thống kê chính thức thu nhập của các user, hiển thị tại trang phân tích */
export function useGetFinalStaffRevenue(object: { startDate: string, endDate: string }) {
    return useQuery({
        queryKey: ['analytics/staff_revenue_final', object],
        queryFn: () => axios.get<{
            "user_id": string,
            "display_name": string,
            "user_phonenumber": string,
            "total_order": number,
            "total_fare": number,
            "total_passenger": number,
            "total_good": number,
            rank: number,
            is_top: boolean

        }[]>(`/analytics/staff_revenue_final${helpers.buildEndUrl(object)}`).then((response) => response.data),
        retry: 1,
    });
}


/** Tải về excel bản đang xem */
export function useDownloadStaffRevenue() {
    return useMutation({
        mutationKey: ["analytics/staff_revenue_final/download"],
        mutationFn: (object: { startDate: string, endDate: string, user_id: string }) => axios.get<Blob>(`/analytics/staff_revenue_final/download${helpers.buildEndUrl(object)}`, { responseType: 'blob', }).then(response => response.data),
    })
}


export function useGetJourneyRevenue(object: { startDate: string, endDate: string }) {
    return useQuery({
        queryKey: ['analytics/revenue_by_journey', object],
        queryFn: () => axios.get<{
            "journey_id": string,
            "journey_name": string,
            "order_count": number,
            "revenue": number,
            "trip_count": number
        }[]>(`/analytics/revenue_by_journey${helpers.buildEndUrl(object)}`).then((response) => response.data),
        retry: 1,
    });
}
